import type { SVGProps } from 'react';

/**
 * BlackBlack icon set — custom 24×24 line icons (2px stroke, rounded caps),
 * filled variants for active states. No external icon dependency.
 */
const P = {
  home: 'M3.5 10.2 12 3.5l8.5 6.7V20a1 1 0 0 1-1 1H15v-6.5H9V21H4.5a1 1 0 0 1-1-1z',
  discover: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm3.8-12.8-2.1 5.5-5.5 2.1 2.1-5.5z',
  music: 'M9 18.5V5.5l11-2v13M9 18.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm11-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  plus: 'M12 5v14M5 12h14',
  user: 'M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm-8 9c.6-4 3.9-6.5 8-6.5s7.4 2.5 8 6.5',
  search: 'M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15ZM21 21l-5.2-5.2',
  heart: 'M12 20.5s-8.5-5-8.5-11.2A4.8 4.8 0 0 1 12 6.3a4.8 4.8 0 0 1 8.5 3c0 6.2-8.5 11.2-8.5 11.2Z',
  comment: 'M4 18.5V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8.5L4 20.5Z',
  share: 'M14 4.5 21 11l-7 6.5V14c-5.5 0-8.6 1.6-11 5.5C4 13.5 7.5 9.5 14 8.5Z',
  bookmark: 'M6.5 3.5h11a1 1 0 0 1 1 1V21L12 16.5 5.5 21V4.5a1 1 0 0 1 1-1Z',
  play: 'M7 4.8v14.4a1 1 0 0 0 1.5.9l11.2-7.2a1 1 0 0 0 0-1.7L8.5 3.9A1 1 0 0 0 7 4.8Z',
  pause: 'M7 4.5h3v15H7zM14 4.5h3v15h-3z',
  next: 'M5 5.5v13l9-6.5zM18 5v14',
  prev: 'M19 5.5v13L10 12zM6 5v14',
  shuffle: 'M3 7h3.5c2 0 3.2 1 4.3 2.6l2.4 4.8c1.1 1.6 2.3 2.6 4.3 2.6H21m0 0-3 3m3-3-3-3M3 17h3.5c1.4 0 2.4-.5 3.2-1.3m4.6-7.4c.8-.8 1.8-1.3 3.2-1.3H21m0 0-3-3m3 3-3 3',
  repeat: 'M17 3.5 20.5 7 17 10.5M20.5 7H7a3.5 3.5 0 0 0-3.5 3.5V12M7 20.5 3.5 17 7 13.5M3.5 17H17a3.5 3.5 0 0 0 3.5-3.5V12',
  volume: 'M4 9.5h3.5L12 5.5v13l-4.5-4H4zM16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12',
  mute: 'M4 9.5h3.5L12 5.5v13l-4.5-4H4zM16.5 9.5l5 5m0-5-5 5',
  back: 'M15 5 8 12l7 7',
  down: 'M5 9l7 7 7-7',
  right: 'M9 5l7 7-7 7',
  up: 'M5 15l7-7 7 7',
  more: 'M5.5 12h.01M12 12h.01M18.5 12h.01',
  close: 'M6 6l12 12M18 6 6 18',
  bell: 'M6 16.5V11a6 6 0 1 1 12 0v5.5l1.5 2H4.5zM10 21h4',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7.4-1.6.1-1.4-.1-1.4 2-1.5-2-3.4-2.3 1a7.5 7.5 0 0 0-2.4-1.4L14.3 3h-4l-.4 2.5c-.9.3-1.7.8-2.4 1.4l-2.3-1-2 3.4 2 1.5-.1 1.4.1 1.4-2 1.5 2 3.4 2.3-1c.7.6 1.5 1.1 2.4 1.4l.4 2.5h4l.4-2.5c.9-.3 1.7-.8 2.4-1.4l2.3 1 2-3.4z',
  check: 'M4.5 12.5l5 5 10-11',
  queue: 'M4 6h12M4 11h12M4 16h7M17 14v6l4-3z',
  playlistAdd: 'M4 6h12M4 11h12M4 16h7M18 13v8M14 17h8',
  trash: 'M4.5 6.5h15M9.5 6.5V4h5v2.5M6.5 6.5l1 14h9l1-14',
  flag: 'M5 21V4m0 0h11l-2 4 2 4H5',
  ban: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM5.6 5.6l12.8 12.8',
  edit: 'M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4',
  camera: 'M4 7.5h3L8.5 5h7L17 7.5h3a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8.5a1 1 0 0 1 1-1ZM12 17a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z',
  upload: 'M12 16V4m0 0L7 9m5-5 5 5M4 15v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4',
  image: 'M4 4h16v16H4zM4 16l5-5 4 4 2-2 5 5M15.5 9.5a1.5 1.5 0 1 0 0-.01',
  lock: 'M6 10.5h12V20H6zM8.5 10.5V7.5a3.5 3.5 0 0 1 7 0v3',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm-9-9h18M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9c-2.5-2.5-3.5-5.5-3.5-9s1-6.5 3.5-9Z',
  users: 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 9.5c.5-3.5 3.3-5.5 7-5.5s6.5 2 7 5.5M16 3.5a4 4 0 0 1 0 7.5m2.5 3.5c2 .8 3.2 2.6 3.5 5',
  logout: 'M14 4h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-5M10 16l-4-4 4-4M6 12h10',
  shield: 'M12 3 4.5 6v5.5c0 4.5 3.2 8 7.5 9.5 4.3-1.5 7.5-5 7.5-9.5V6z',
  hash: 'M9 3.5 7 20.5M17 3.5l-2 17M4 9h16.5M3.5 15H20',
  disc: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  link: 'M10 14a4 4 0 0 0 5.7 0l3.3-3.3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0L5 13.3a4 4 0 0 0 5.7 5.7l1-1',
  note: 'M10 17.5V4.5l8-1.5v3l-8 1.5M10 17.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  eye: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Zm9.5 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  record: 'M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z',
  stop: 'M6.5 6.5h11v11h-11z',
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  grid: 'M4 4h7v7H4zM13 4h7v7h-7zM4 13h7v7H4zM13 13h7v7h-7z',
  verified: 'M12 2.5l2.4 1.8 3-.2.9 2.9 2.4 1.8-1 2.8 1 2.8-2.4 1.8-.9 2.9-3-.2L12 21.5l-2.4-1.8-3 .2-.9-2.9-2.4-1.8 1-2.8-1-2.8 2.4-1.8.9-2.9 3 .2Z',
  alert: 'M12 9v4.5M12 17h.01M10.3 4.3 2.6 18a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.3a2 2 0 0 0-3.4 0Z',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7M20 4.5V11h-6.5',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z',
} as const;

const FILLED: Partial<Record<IconName, true>> = { play: true, pause: true, next: true, prev: true, record: true, stop: true, verified: true };

export type IconName = keyof typeof P;

interface IconProps extends Omit<SVGProps<SVGSVGElement>, 'name'> {
  name: IconName;
  size?: number;
  filled?: boolean;
  strokeWidth?: number;
  title?: string;
}

export function Icon({ name, size = 24, filled, strokeWidth = 2, title, ...rest }: IconProps) {
  const fill = filled ?? FILLED[name] ?? false;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth={fill && (name === 'play' || name === 'pause' || name === 'record' || name === 'stop') ? 0 : strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title && <title>{title}</title>}
      <path d={P[name]} />
    </svg>
  );
}
